import React, { useState } from 'react'
import EditIcon from '../../common/icons/editIcon'
import DeleteIcon from '../../common/icons/deleteIcon'
import { ReactComponent as TextIcon } from '../../common/icons/text-_icon.svg'
import { ReactComponent as PreviewIcon } from '../../common/icons/play_icon.svg'
import DeleteDialog from '../../common/components/DeleteDialog'

import RenameModuleModal from './RenameModuleModal'
import useMutation from '../../hooks/useMutation'
import { useDeleteCustomModuleMutation } from '../../api/trainingTopics'
import ActionButtons from '../../common/components/ActionButtons'
import { CircularProgress } from '@mui/material'

export default function ModuleItem({ isGenerating, item, index, onPreview, onEdit }) {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false)
  const [isRenameModalOpen, setIsRenameModalOpen] = useState(false)

  const { submit: handleDelete } = useMutation(useDeleteCustomModuleMutation, {
    successMessage: 'Module successfully deleted'
  })
  const actionConfig = [
    {
      name: 'Rename',
      icon: <TextIcon style={{ width: 20, height: 20 }} />,
      onClick: () => setIsRenameModalOpen(true),
      isHidden: item?.type == 'INTERNAL'
    },
    {
      name: 'Edit',
      icon: <EditIcon color='#ffffff' size='20' />,
      onClick: onEdit
    },
    {
      name: 'Preview',
      icon: <PreviewIcon style={{ width: 20, height: 20, stroke: '#ffffff' }} />,
      onClick: () => onPreview(item?.trainingModuleId)
    },
    {
      name: 'Delete',
      icon: <DeleteIcon color={'#FFFFFF'} />,
      onClick: () => setIsDeleteDialogOpen(true),
      isHidden: item?.type == 'INTERNAL'
    }
  ]

  return (
    <div className={`row row-center module-element ${item.active && 'module-element-active'}`}>
      {isGenerating ? (
        <div className='row row-center'>
          <CircularProgress
            sx={{
              '& svg': {
                color: '#6123FF'
              },
              marginRight: '10px'
            }}
            size='18px'
          />
          <p>{item?.name}</p>
        </div>
      ) : (
        <p
          style={{ marginLeft: '10px', cursor: 'pointer' }}
          onClick={() => onPreview(item?.trainingModuleId)}
          onMouseOver={e => (e.currentTarget.style.textDecoration = 'underline')}
          onMouseOut={e => (e.currentTarget.style.textDecoration = 'none')}
        >
          {index + 1}.{item.module}
        </p>
      )}
      <div className='spacer'></div>

      {!isGenerating && <ActionButtons config={actionConfig} />}

      {isDeleteDialogOpen && (
        <DeleteDialog
          open={isDeleteDialogOpen}
          onClose={() => setIsDeleteDialogOpen(false)}
          onAction={() => handleDelete({ topicId: item?.trainingId, moduleId: item?.trainingModuleId })}
          str={item?.module}
          description='This module and all its cards will be deleted permanently.'
        />
      )}

      {isRenameModalOpen && (
        <RenameModuleModal open={isRenameModalOpen} handleClose={() => setIsRenameModalOpen(false)} rowData={item} />
      )}
    </div>
  )
}
